import { t } from "@lingui/macro"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { FormFieldSet } from "src/components/FormFieldSet"
import { SegmentPickerField } from "src/components/SegmentPickerField"
import { FormDetailStore } from "src/modals/contact-forms-form-builder/store"
import { useStore } from "src/store/lib/useStore"

export const PublishingSettingsSection = observer(() => {
    const store = useStore(FormDetailStore)

    const handleSegmentsChange = useCallback(
        (segmentIds: number[]) => {
            store.formFields.set("segmentIds", segmentIds)
        },
        [store.formFields],
    )

    const handlePublishGroupChange = useCallback(
        (publishGroupIds: number[]) => {
            store.formFields.set("dimensionIds", publishGroupIds)
        },
        [store.formFields],
    )

    return (
        <FormFieldSet
            header={t`resource-detail-modal.publishing-settings-section.field-set-header`}
        >
            <SegmentPickerField
                value={store.formFields.get("segmentIds") ?? []}
                accessGroupId={store.formFields.get("accessGroupId")}
                onChange={handleSegmentsChange}
                dimensionIds={store.formFields.get("dimensionIds")}
                onPublishGroupChange={handlePublishGroupChange}
            />
        </FormFieldSet>
    )
})
